export enum AppPaths {
	EMAIL_CONFIRMATION = 'email-confirmation',

	LOGIN = 'login',
	REGISTER = 'register',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	CART = 'cart',

	ACCOUNT = 'account',

	CREATOR = 'creator',

	USER_NOTIFICATIONS = 'user-notifications',

	ORDERS = 'orders',
	ORDER_CONFIRMATION = 'order-confirmation',
	SUBMIT = 'submit',
	OFFERS = 'offers',

	COMPANY = 'company',
	ADDRESSES = 'addresses',

	PRODUCT_TYPES = 'product-types',

	COMPLAINTS = 'complaints',
	FILES = 'files',
	CLIENTS = 'clients',
	CONTACTS = 'contacts',
}
